export const btn = [
    {
        title:'Primary',
        style:'btn-primary'
    },
    {
        title:'Secondary',
        style:'btn-secondary'
    },
    {
        title:'Success',
        style:'btn-success'
    },
    {
        title:'Danger',
        style:'btn-danger'
    },
    {
        title:'Info',
        style:'btn-info'
    },
    {
        title:'Warning',
        style:'btn-warning'
    },
    {
        title:'Light',
        style:'btn-light'
    },
    {
        title:'Dark',
        style:'btn-dark'
    },
]
export const btnOutLine = [
    {
        title:'Primary',
        style:'btn-outline-primary'
    },
    {
        title:'Secondary',
        style:'btn-outline-secondary'
    },
    {
        title:'Success',
        style:'btn-outline-success'
    },
    {
        title:'Danger',
        style:'btn-outline-danger'
    },
    {
        title:'Info',
        style:'btn-outline-info'
    },
    {
        title:'Warning',
        style:'btn-outline-warning'
    },
    {
        title:'Light',
        style:'btn-outline-light'
    },
    {
        title:'Dark',
        style:'btn-outline-dark'
    },
]

export const badges = [
    {
        title:'Primary',
        style:'bg-primary'
    },
    {
        title:'Secondary',
        style:'bg-secondary'
    },
    {
        title:'Success',
        style:'bg-success'
    },
    {
        title:'Danger',
        style:'bg-danger'
    },
    {
        title:'Warning',
        style:'bg-warning'
    },
    {
        title:'Info',
        style:'bg-info'
    },
    {
        title:'Light',
        style:'bg-light'
    },
    {
        title:'Dark',
        style:'bg-dark'
    },
]

export const textColor = [
    {
        title:'.text-primary',
        style:'text-primary'
    },
    {
        title:'.text-secondary',
        style:'text-secondary'
    },
    {
        title:'.text-success',
        style:'text-success'
    },
    {
        title:'.text-danger',
        style:'text-danger'
    },
    {
        title:'.text-warning',
        style:'text-warning'
    },
    {
        title:'.text-info',
        style:'text-info'
    },
    {
        title:'.text-light',
        style:'text-light bg-dark'
    },
    {
        title:'.text-white',
        style:'text-white bg-dark'
    },
    {
        title:'.text-white-50',
        style:'text-muted bg-dark'
    },
    {
        title:'.text-dark',
        style:'text-dark'
    },
]

export const progress = [
    {
        title:'WordPress',
        value:'84%'
    },
    {
        title:'PHP / MYSQL',
        value:'75%'
    },
    {
        title:'Angular / JavaScript',
        value:'79%'
    },
    {
        title:'HTML',
        value:'95%'
    },
]